import React, { Component } from 'react';
import PropTypesReact from 'prop-types';
import { PropTypes } from 'mobx-react';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';

import { ReactComponent as Arrow } from '../../../../../common/images/down-arrow.svg';

import styles from './NavList.module.scss';

import { isOnMobile } from 'utils/device-utils.js';

export default class NavList extends Component {
  static propTypes = {
    products: PropTypes.arrayOrObservableArray,
    onChangeSlide: PropTypesReact.func.isRequired,
    activeSlideIndex: PropTypesReact.number.isRequired,
    fadeInActive: PropTypesReact.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.products = props.products;
    this.state = {
      activeSlideIndex: props.activeSlideIndex,
      fadeInActive: props.fadeInActive,
      isMobile: isOnMobile(),
      showMenu: false
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.state.activeSlideIndex !== props.activeSlideIndex) {
      this.setState({ activeSlideIndex: props.activeSlideIndex });
    }
    if (this.state.fadeInActive !== props.fadeInActive) {
      this.setState({ fadeInActive: props.fadeInActive });
    }
  }

  @Bind()
  @Debounce(100)
  updateDimensions() {
    this.setState({
      isMobile: isOnMobile()
    });
  }

  render() {
    const { isMobile } = this.state;

    if (!isMobile) {
      const navList = this.products.map((product, index) => {
        const isActive = index === this.state.activeSlideIndex;
        return (
          <span
            key={index}
            className={`${styles.Link}  ${isActive ? styles.Active : ''}`}
            onClick={() => this.onChangeSlide(index)}
          >
            {product.title}
          </span>
        );
      });
      return <div className={styles.NavList}>{navList}</div>;
    } else if (!this.state.showMenu && this.products.length) {
      return (
        <span
          key={this.state.activeSlideIndex}
          className={`${styles.Link}  ${styles.Active}`}
          onClick={() => this.showMenu()}
        >
          {this.products[this.state.activeSlideIndex].title}
          <Arrow className={styles.Arrow} />
        </span>
      );
    } else {
      const navList = this.products.map((product, index) => {
        const isActive = index === this.state.activeSlideIndex;
        return (
          <span
            key={index}
            className={`${styles.Link}  ${
              isActive ? styles.ActiveDropDown : ''
            }`}
            onClick={() => this.onChangeSlide(index)}
          >
            {product.title}
          </span>
        );
      });
      return (
        <div
          className={styles.DropDownOpened}
          ref={element => {
            this.dropdownMenu = element;
          }}
        >
          {navList}
        </div>
      );
    }
  }

  setActive(index) {
    this.setState({
      activeSlideIndex: index
    });
  }

  onChangeSlide(index) {
    if (!this.state.fadeInActive) {
      this.props.onChangeSlide(index);
      this.setActive(index);
      this.hideMenu();
    }
  }

  hideMenu() {
    this.setState({
      showMenu: false
    });
  }

  showMenu() {
    this.setState({
      showMenu: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Products/Components/NavList/NavList.js